module.exports = __webpack_public_path__ + "img/26.f1d62d1.png";